<template>
  <div class="kanban-col">
    <div class="title">
      <div class="text-truncate">
        <input type="checkbox" @click="toggleCheckAll" :checked="checkedAll" />
        <span v-tooltip="stage.name">
          {{ stage.name }}
        </span>
      </div>
      <span class="total">({{ totalByStage }})</span>
    </div>

    <div
      v-if="stage.name === 'Candidatura' && resourceAvailability.features.includes('matcher')"
      class="bt-match">
      <a
        class="btn btn-light btn-block"
        :href="`/#/job/${job._id}/grid?placements.elemMatch.status=qualified&page=1&placements.elemMatch.stage_id=${stage._id}&sort=-placements.elemMatch.match_score`"><i class="fa-solid fa-list-check"></i> Por aderência</a>
    </div>

    <div :data-droppable="stage._id" class="droppable">
      <VuePerfectScrollbar class="scroll-area">
        <ul class="candidate-list" ref="candidate-list">
          <job-board-stages-item
            v-for="(item, index) in stageCandidates"
            :key="index"
            :candidate="item"
          >
          </job-board-stages-item>
        </ul>

        <button
          class="btn btn-sm btn-block btn-light"
          v-if="stageInfo && stageInfo.has_more"
          @click="loadMore()"
          :class="{ 'box-loading': loading }"
        >
          {{ $t('More') }}
        </button>
      </VuePerfectScrollbar>
    </div>
  </div>
</template>

<script>
import JobBoardStagesItem from './JobBoardStagesItem'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  name: 'JobBoardStages',
  components: {
    JobBoardStagesItem,
    VuePerfectScrollbar
  },
  props: ['stage', 'status', 'candidates', 'boardFilters'],
  data () {
    return {
      loading: false
    }
  },
  computed: {
    resourceAvailability () {
      return this.$store.getters.getAccountResourceAvailability
    },
    account () {
      return this.$store.getters.getAccount
    },
    candidateId () {
      return this.$route.query.candidate_id
    },
    selected () {
      return this.$store.getters.getCandidateSelectedIds
    },
    job () {
      return this.$store.getters.getJob
    },
    stageCandidates () {
      return this.candidates.filter((candidate) => {
        return (
          candidate.placement &&
          candidate.placement.stage_id._id === this.stage._id &&
          candidate.placement.status === this.status
        )
      })
    },
    totalByStage () {
      const stage = this.job.pipeline.stages.find((stage) => stage.stage_id === this.stage._id)
      return this.status === 'qualified' ? stage.qualified : stage.disqualified
    },
    checkedAll () {
      return (
        this.stageCandidates.length &&
        !this.stageCandidates.find((v) => !this.selected.includes(v._id))
      )
    },
    stageInfo () {
      return this.$store.getters.getCandidateBoardsStages[this.stage._id]
    }
  },
  watch: {
    candidateId (id) {
      if (id) {
        const index = this.stageCandidates.findIndex((item) => {
          return item._id === id
        })
        const triggerIndex = this.stageCandidates.length - 3
        if (triggerIndex >= 0 && index >= triggerIndex && this.stageInfo.has_more) {
          this.loadMore()
        }
      }
    }
  },
  methods: {
    /*
    loadMore
    */
    loadMore () {
      this.loading = true

      const params = {
        ...this.boardFilters,
        stage_id: this.stage._id,
        skip: this.stageCandidates.length
      }

      this.$store.dispatch('selectCandidateStageBoard', params).then((result) => {
        this.loading = false
      })
    },
    /*
    toogleCheckAll
    */
    toggleCheckAll () {
      const checkedAll = this.checkedAll
      this.stageCandidates.forEach((candidate) => {
        const action = checkedAll ? 'removeCandidateSelected' : 'addCandidateSelected'
        this.$store.dispatch(action, candidate._id)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.kanban-col {
  min-width: 160px;
  flex: 1 100px;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.kanban-col .title {
  flex: 0 1px;
  padding: 7px;
  font-weight: bold;
  display: flex;
  gap: 6px;
}
.kanban-col .title .total {
  color: rgba(0, 0, 0, 0.5);
}
.kanban-col .droppable {
  flex: 1 20px;
  background: #ebebeb;
  padding: 7px;
  overflow: auto;
}
.kanban-col .droppable.ui-state-hover {
  background: #e0e0e0;
  border: 2px dashed #bdbdbd;
}

.bt-match {
  background: #ebebeb;
  padding: 7px 7px 0 7px;
}

.scroll-area {
  position: relative;
  height: 100%;
}

.candidate-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Job/JobBoard/JobBoardStages.vue